// Central catalog of data-testid identifiers used throughout the landing page.
export const TID = {
  nav: {
    root: 'main-nav',
    brand: 'nav-brand',
    linkAbout: 'nav-link-about',
    linkServices: 'nav-link-services',
    linkApproach: 'nav-link-approach',
    linkInsights: 'nav-link-insights',
    linkContact: 'nav-link-contact',
    ctaTalk: 'nav-cta-lets-talk',
    menuToggle: 'nav-menu-toggle',
  },
  hero: {
    root: 'hero-section',
    name: 'hero-name',
    title: 'hero-title',
    tagline: 'hero-tagline',
    ctaBook: 'hero-cta-book',
    ctaView: 'hero-cta-view-services',
    portrait: 'hero-portrait',
  },
  intro: 'intro-quote-section',
  about: 'about-section',
  services: {
    root: 'services-section',
    item: (key) => `service-item-${key}`,
  },
  expertise: 'featured-expertise-section',
  industries: 'industries-section',
  approach: {
    root: 'approach-section',
    step: (i) => `approach-step-${i}`,
    principles: 'approach-principles',
  },
  insights: {
    root: 'insights-section',
    card: (i) => `insight-card-${i}`,
  },
  contact: {
    root: 'contact-section',
    form: 'contact-form',
    name: 'contact-input-name',
    email: 'contact-input-email',
    phone: 'contact-input-phone',
    company: 'contact-input-company',
    message: 'contact-input-message',
    submit: 'contact-submit-btn',
    success: 'contact-success-message',
    error: 'contact-error-message',
    infoEmail: 'contact-info-email',
    infoPhone: 'contact-info-phone',
    infoLocation: 'contact-info-location',
  },
  footer: {
    root: 'footer-section',
    display: 'footer-display-text',
    email: 'footer-email',
    linkedin: 'footer-linkedin',
    copyright: 'footer-copyright',
  },
};
